// extracted by mini-css-extract-plugin
export var wrapper = "BlockContent-module--wrapper--e266d";